<div class="user-credit-requests">
  <app-table
    [columns]="columns"
    [data]="creditRequestsData"
    [scrollHeight]="'400px'"
    [loading]="loading"
    [pagination]="pagination"
    [emptyMessage]="emptyMessage"
    [striped]="true"
    [bordered]="true"
    [hoverable]="true"
    (pageChange)="onPageChange($event)"
    (pageSizeChange)="onPageSizeChange($event)"
    (sortChange)="onSortChange($event)"
  >
    <!-- Custom Status Column -->
    <ng-template #statusCell let-row>
      <div [ngClass]="getStatusChipClass(row.status)">
        {{ row.status }}
      </div>
    </ng-template>

    <!-- Custom Action Column (dropdown in fixed overlay below) -->
    <ng-template #actionCell let-row>
      <div class="action-cell-wrapper">
        <button 
          class="action-btn" 
          (click)="toggleActionDropdown($event, row)"
          [class.active]="isDropdownOpen(row)"
          type="button"
        >
          <span>Action</span>
        </button>
      </div>
    </ng-template>
  </app-table>
</div>

<!-- Fixed overlay: dropdown on top of table -->
<div
  *ngIf="dropdownPosition && openDropdownRow"
  class="action-dropdown-overlay"
  [style.top.px]="dropdownPosition.top"
  [style.left.px]="dropdownPosition.left"
  [style.min-width.px]="dropdownPosition.width"
  (click)="$event.stopPropagation()"
>
  <ul class="dropdown-list">
    <li class="dropdown-item">
      <button type="button" class="dropdown-link" (click)="handleAction('view', openDropdownRow)">
        View
      </button>
    </li>
    <li class="dropdown-item">
      <button
        type="button"
        class="dropdown-link"
        [class.disabled]="isRequestProcessed(openDropdownRow)"
        [disabled]="isRequestProcessed(openDropdownRow)"
        (click)="!isRequestProcessed(openDropdownRow) && handleAction('approve', openDropdownRow)"
      >
        Approve
      </button>
    </li>
    <li class="dropdown-item">
      <button
        type="button"
        class="dropdown-link dropdown-link--danger"
        [class.disabled]="isRequestProcessed(openDropdownRow)"
        [disabled]="isRequestProcessed(openDropdownRow)"
        (click)="!isRequestProcessed(openDropdownRow) && handleAction('reject', openDropdownRow)"
      >
        Reject
      </button>
    </li>
  </ul>
</div>

<!-- Approve Modal -->
<app-modal
  [(visible)]="isApproveModalVisible"
  header="Approve Request"
  [width]="'500px'"
  [modal]="true"
  [closable]="true"
  confirmLabel="Approve"
  cancelLabel="Cancel"
  [confirmButtonDisabled]="!newCredits || newCredits <= 0 || !expirationDate || !expirationDate.startDate"
  (onConfirm)="onApproveConfirm()"
  (onCancel)="closeApproveModal()"
  (onClose)="closeApproveModal()"
>
  <div class="approve-modal-content">
    <div class="form-field">
      <label class="form-label">New Credits *</label>
      <input
        type="number"
        class="form-input"
        [(ngModel)]="newCredits"
        placeholder="Enter new credits"
        min="0"
        step="0.01"
      />
    </div>

    <div class="form-field">
      <label class="form-label">Total Credits</label>
      <div class="total-credits-display">
        {{ getOldCredits() }} + {{ newCredits || 0 }} = {{ getTotalCredits() }}
      </div>
    </div>

    <div class="form-field">
      <label class="form-label">Expiration Date *</label>
      <app-date-range-picker
        [(ngModel)]="expirationDate"
        [singleDateMode]="true"
        [minDate]="minDate"
        [disableFutureDates]="false"
        placeholder="Select expiration date"
        styleClass="approve-modal-date-picker"
      ></app-date-range-picker>
    </div>
  </div>
</app-modal>

<!-- View Request Modal -->
<app-modal
  [(visible)]="isViewModalVisible"
  header="Credit Request Details"
  [width]="'90vw'"
  [modal]="true"
  [closable]="true"
  [showFooter]="false"
  (onClose)="closeViewModal()"
>
  <div class="view-modal-content" *ngIf="viewRequest">
    <app-request-credits
      [initialData]="viewRequest.additionalInfo"
      [readOnly]="true"
    ></app-request-credits>
  </div>
</app-modal>
